<template>
  <div class="fb-eoc-vitals-v2">
    <div v-if="showType == 'form-builder'" :style="properties.style">
      <b-form-group
        :description="
          superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'description',
            value: properties.description,
            defaultValue: '',
            form: this.form
          })
        "
        :label="
          superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'label',
            value: properties.label,
            defaultValue: '',
            form: this.form
          })
        "
        :style="properties.style"
      >
        <fb-table-v1
          :showType="showType"
          :properties="tableProperties"
          :id="id"
          :form="form"
        ></fb-table-v1>
      </b-form-group>
    </div>
    <div v-else-if="showType == 'properties'">
      <eoc-vitals-v2-properties :formId="formId" />
    </div>
    <div v-if="showType == 'form-submitter'" :style="properties.style">
      <b-form-group
        style="font-size:14px;"
        :description="
          superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'description',
            value: properties.description,
            defaultValue: '',
            form: this.form
          })
        "
        :style="properties.style"        
        v-show="!computedHidden"
      >
        <template v-slot:label="">
          <div class="d-flex align-items-center mb-3">
            <span class="mr-3">
              {{
                superComputeFormSubmitterValue({
                  elementId: id,
                  property: "label",
                  value: properties.label,
                  defaultValue: "",
                  form: form
                })
              }}
            </span>
            <b-form-select
              v-if="!properties.hidePicker"
              v-model="controlValue"
              :options="options"
              style="width: 450px; font-size:14px;"
            />
          </div>
        </template>
        <fb-table-v1
          v-if="controlValue"
          :showType="showType"
          :properties="tableProperties"
          :id="id"
          :form="form"
        ></fb-table-v1>
      </b-form-group>
    </div>
    <div v-if="showType == 'form-viewer'" :style="properties.style">
      <fb-table-v1
        :showType="showType"
        :properties="tableProperties"
        :id="id"
        :form="form"
      ></fb-table-v1>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import { formatDate } from "../../../../helpers/date";
import EocVitalsV2Properties from "./EocVitalsV2Properties.vue";
import vitalRecordServer from "../../../../server/vitalRecord";
export default {
  name: "EocVitalsV2",
  components: { EocVitalsV2Properties },
  props: ["showType", "properties", "form", "id", "formId"],
  data() {
    return {
      computedProperties: ["description", "label", "hidden"],
      computedConditions: {},
      vitalRecords: []
    };
  },
  async mounted() {
    if (this.showType == "e-form") {
      return;
    }
    
    if (
      !this.getFormSubmitterComponentValue(this.id) &&
      this.showType == "form-submitter"
    ) {
      this.setFormSubmitterComponentValue({
        controlId: this.id,
        controlValue:
          typeof this.properties.value == "string" &&
          this.properties.value.includes("{{")
            ? this.superComputeFormSubmitterValue({
                elementId: this.id,
                property: "value",
                value: this.properties.value,
                defaultValue: "",
                form: this.form
              })
            : ""
      });
    }

    if (this.showType != "form-builder") {
      const vitals = await vitalRecordServer.query(
        false,
        this.client.episodeOfCare.id
      );
      this.vitalRecords = vitals
        .sort((a, b) => {
          return a.effectiveDate.localeCompare(b.effectiveDate);
        })
        .reverse()
        .map(vital => {
          let vitalItems = "";
          for (let index = 0; index < vital.items.length; index++) {
            const item = vital.items[index];
            vitalItems += `${item.vitalSign.name}: ${item.value}\n`;
          }
          return {
            effectiveDate: formatDate(vital.effectiveDate),
            user: vital.user ? this.formatUser(vital.user) : "",
            items: vitalItems,
            id: vital.id
          };
        });
    }

    const preCode = `patient.episodeOfCare.vitals = ${JSON.stringify(
      this.vitalRecords
    )};`;
    if (
      this.showType == "form-submitter" &&
      this.properties.value.includes("{{")
    ) {
      this.vitalRecords = this.superComputeFormSubmitterValue({
        elementId: this.id,
        property: "value",
        value: this.properties.value,
        defaultValue: "",
        form: this.form,
        preCode: preCode
      });
    }
    
    if (this.showType != "form-builder") {
      if (!this.controlValue) {
        this.controlValue = this.vitalRecords.length
          ? this.options[1].value
          : this.options[0].value;
      }
    }

    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group is-table" id="__BVID__48">
        <legend style="font-size:14px;" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" id="__BVID__48__BV_label_">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <div>
            <div>
              <table role="table" aria-busy="false" aria-colcount="3" class="table b-table custom-fb-table mt-2 table-striped table-hover" id="__BVID__50">
                <thead role="rowgroup" class="">
                  <tr role="row" class="">
                    <th role="columnheader" scope="col" aria-colindex="1" class="">
                      <div style="font-size:14px;">Date</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="2" class="">
                      <div style="font-size:14px;">Creator</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="3">
                      <div style="font-size:14px;">Vitals</div>
                    </th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                ${(this.tableProperties.items || [])
                  .map(
                    item => `
                  <tr role="row" class="">
                    <td style="font-size:14px;" aria-colindex="1" role="cell" class="">${item.effectiveDate}</td>
                    <td style="font-size:14px;" aria-colindex="2" role="cell" class="">${item.user}</td>
                    <td style="font-size:14px;" aria-colindex="3" role="cell" style="white-space: pre-wrap;">${item.items}</td>
                  </tr>
                `
                  )
                  .join("")}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue",
      "computeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      client: state => state.form.client
    }),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    ...mapGetters("client", ["vitalSignsCurrentLocation"]),
    options() {
      const options = this.vitalRecords.map(u => ({
        value: { id: u.id, text: `${u.effectiveDate} by ${u.user}` },
        text: `${u.effectiveDate} by ${u.user}`
      }));

      options.unshift({ value: { id: "all", text: "All" }, text: "All" });

      return options;
    },
    vitalSigns() {
      return this.vitalSignsCurrentLocation.filter(
        vitalSign => vitalSign.status == "Enabled"
      );
    },
    tableProperties() {
      let items = this.vitalRecords.slice();
      if (
        this.vitalRecords.length &&
        this.controlValue &&
        !this.properties.hidePicker
      ) {
        items =
          this.controlValue.id == "all"
            ? this.vitalRecords.slice()
            : [this.vitalRecords.find(u => u.id == this.controlValue.id)];
      }

      return {
        ...this.properties,
        items: items,
        columns: [
          {
            key: "effectiveDate",
            label: "Date"
          },
          {
            key: "user",
            label: "Creator"
          },
          {
            key: "items",
            label: "Vitals",
            class: "pre-wrap"
          }
        ]
      };
    },
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'hidden',
            value: this.properties.hidden,
            defaultValue: false,
            form: this.form
          })
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>
